export default function PatientDetails({
  patient = {},
  lastAction = null,
  showMultipleActions = false,
}) {
  const { firstname, lastname, participantId } = patient;

  return (
    <div className="w-full mb-6">
      <div className="mb-1">
        <span className="font-medium">Patient name : </span>
        <span>{firstname + " " + lastname}</span>
      </div>

      <div className="mb-4">
        <span className="font-medium">Patient ID : </span>
        <span className="font-mono break-words break-all max-w-full block">
          {participantId}
        </span>
      </div>

      {lastAction && (
        <div className="mb-2">
          <div className="font-medium mb-1">Last action :</div>
          <div className="pl-0">{lastAction.description}</div>
          {lastAction.date && <div className="pl-0">{lastAction.date}</div>}
        </div>
      )}

      {showMultipleActions && lastAction && lastAction.previousActions && (
        <div className="mt-4">
          {lastAction.previousActions.map((action, index) => (
            <div key={index} className="mb-2">
              <div>{action.description}</div>
              {action.date && <div>{action.date}</div>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
